import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { isChunkLoadError, reloadForChunkLoadError } from './app/common/util/chunk-load-util';
import { shouldDropSentryEvent } from './app/common/util/sentry-event-filter';

if(environment.sourceName.toLocaleLowerCase().indexOf('local') < 0){
  console.log = function () { };
  console.warn = function () { };
  console.info = function () { };
}
if (environment.production) {
  // disable console logs
  enableProdMode();
}

// Stale-chunk errors after a deploy: reload once to pick up the current build.
// Router lazy-load failures reach GlobalErrorHandler instead, which does the same.
window.addEventListener('unhandledrejection', event => {
  if (!isChunkLoadError(event.reason?.message)) return;
  reloadForChunkLoadError();
});

Sentry.init({
  dsn: environment.sentryTokenUrl,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,

  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false
    })
  ],
  // Session Replay
  replaysSessionSampleRate: environment.production ? 1.0 : 0.1, // Record 100% of all sessions in production, 10% otherwise
  replaysOnErrorSampleRate: 1.0, // Record 100% of sessions containing errors

  environment: environment.sourceName,

  beforeSend(event, hint) {
    return shouldDropSentryEvent(event, hint?.originalException) ? null : event;
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
